export const API = {
  BASE_URL: "https://setaregan.datis-elevator.ir/AdminAPI",

  // RECORDS
  GET_ALL_RECORDS: "/api/Install/GetAllRecords",

  // USER
  GET_ALL_USERS: "/api/Admin/GetAllUsers",
  GET_USERS: "/api/User/GetUsers",
  CREATE_USER: "/api/User/Create",
  EDIT_USER: "/api/User/Edit",
  DELETE_USER: "/api/User/DeleteConfirmed/",
  GET_CHARGE_DATA_REPORT: "/api/Report/getChargeData",
  LOGIN: "/api/User/Login",
  REGISTER: "/api/User/Register",

  // INSTALL
  GET_INSTALL_PRODUCT: "/api/Admin/GetInstallProduct",
  GET_INSTALLED_DATA_REPORT: "/api/Report/getInstallData",
  INSTALL: "/api/Install/GetAllRecords",

  // CODE
  GET_ALL_CODES: "/api/LotteryCode/GetAllCodes",

  // REGISTER
  GET_REGISTER_DATA_REPORT: "/api/Report/getRegisterData",

  // CHARGE
  GET_CHARGE_DETAILS: "/api/Charge/DetailsCharge",
  INQUIRY: "/api/Charge/Inquery",
  GET_CREDIT: "/api/Charge/getCredit",

  // SERVICE
  SERVICE_RECORDS: "/api/Service/ServiceRecords",

  // CODE
  GENERATE_NEW_CODE: "/api/LotteryCode/GenerateNewCodes",
};

const persianNumbers = [
  /۰/g,
  /۱/g,
  /۲/g,
  /۳/g,
  /۴/g,
  /۵/g,
  /۶/g,
  /۷/g,
  /۸/g,
  /۹/g,
];

export const FixNumbers = (str) => {
  if (typeof str === "string") {
    for (let i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i);
    }
  }
  return str;
};
